import { useTranslation } from '@/locales';
import { useBreakpointsCtx } from '@/providers/BreakpointsProvider/BreakpointsContext.hooks';
import { StyledAgioH1 } from '@/components/StyledSharedComponents/StyledTypography';
import {
  StyledBasicToolbar,
  StyledHeader,
} from '@/layouts/MainLayout/components/HeaderWithNavigation/components/Headers/SharedHeaders.styled';

export const AlertingHeader = () => {
  const { t } = useTranslation('alerting');
  const { isDesktop } = useBreakpointsCtx();

  return (
    <StyledHeader position="static" isDesktop={isDesktop}>
      <StyledBasicToolbar>
        <StyledAgioH1
          noWrap
          color="customSecondary.primary.DEFAULT"
          data-testid="alerting-header-title"
        >
          {t('header.title')}
        </StyledAgioH1>
      </StyledBasicToolbar>
    </StyledHeader>
  );
};
